import { Box, Grid, Icon, Link, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';

// The ELLIS Society, short for European Laboratory for Learning and Intelligent Systems, is committed to ensuring transparency in its use of personal information. This notice explains how we collect and use your personal information as part of the selection procedure for the ELLIS PhD and Postdoc Program, which is managed centrally at the University of Tübingen. Data you submit or upload via the ELLIS application portal (apply.ellis.eu) is stored and processed independently of your visits to the general ELLIS website (ellis.eu). The privacy notice of the ELLIS website (ellis.eu) can be found at ellis.eu/privacy-policy. The following information is only valid for the ELLIS application portal that can be accessed at apply.ellis.eu. By using our platform, you consent to the processing and use of your data as described below.
// The measures we take are subject to constant updating. We are guided by legal requirements, best practices, technical developments and changes to the functional scope of our program. We therefore recommend that you read our data protection declaration at regular intervals.

export default function Imprint() {
  return (
    <Box sx={{margin: '40px 0 0 0 '}} >
        <Typography variant='h5' component='h5' fontWeight='bold' marginBottom={1}>
            Imprint
        </Typography>
        <Typography fontWeight='medium' marginBottom={1}>
            General information according to § 5 TMG, § 55 RStVG
        </Typography>
        <Table sx={{marginBottom: 5}}>
            <TableBody>
                <TableRow>
                    <TableCell>
                        <Typography >
                            Address: 
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography >
                            University of Tübingen
                        </Typography>
                        <Typography>
                            Geschwister-Scholl-Platz
                        </Typography>
                        <Typography>
                            72074 Tübingen
                        </Typography>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                    </TableCell>
                    <TableCell>
                        <Typography >
                            The University of Tübingen is a corporation under public law. Its legal representative is the President and 
                            Vice-Chancellor, Professor Dr. Karla Pollmann (E-Mail: rektorin@uni-tuebingen.de).
                        </Typography>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Typography >
                        Internet address:
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography >
                            <Link color='secondary' href='http://www.uni-tuebingen.de'>http://www.uni-tuebingen.de</Link>
                        </Typography>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Typography >
                            Value added tax ID no.:
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography >
                        according to § 27a Umsatzsteuergesetz:<br/>
                        DE812383453
                        </Typography>
                    </TableCell>
                </TableRow>
                <TableRow>

                    <TableCell>
                        <Typography >
                            Supervisory authority:
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography >
                        Baden-Württemberg Ministry of Science, Research and the Arts<br/>
                        Königstraße 46 a<br/>
                        70173 Stuttgart<br/>
                        Website: <Link color='secondary' href='https://mwk.baden-wuerttemberg.de/de/startseite/'>https://mwk.baden-wuerttemberg.de/de/startseite/</Link>
                        </Typography>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
        <Typography fontWeight='medium' marginBottom={1}>
            Responsible for the content
        </Typography>
        <Typography sx={{margin: '0 0 20px 0 '}}>
            Prof. Dr. Andreas Geiger <br/>
            Autonomous Vision Group <br/>
            Department of Computer Science, University of Tübingen<br/>
            Maria-von-Linden-Str. 6 	<br/>
            72076 Tübingen<br/>
            Phone: 	+49 7071 29 70834<br/>
            Email: 	a.geiger@uni-tuebingen.de<br/>
        </Typography>

        <Typography fontWeight='medium' marginBottom={1}>
            1. External links
        </Typography>
        <Typography sx={{margin: '0 0 20px 0 '}}>
        This University of Tübingen website also contains appropriately marked links  and references to third-party websites. Via any such link, the University of Tübingen merely provides access to the content. This does not imply any approval of the contents of the linked third-party sites. The University of Tübingen therefore accepts no responsibility for the availability or content of such websites and no liability for damage or injury resulting from the use - in whatever form - of such content. The provider of the respective site is solely liable for this.
        When linking to another website for the first time, the editorial team checked the content of that website to see whether it might give rise to any civil or criminal liability. However, it is unfortunately not possible to check content subsequently included there. The link will be removed immediately as soon as the editors notice or are informed by others that a certain site, to which a link has been provided, gives rise to civil or criminal liability.
        </Typography>
        <Typography fontWeight='medium' marginBottom={1}>
            2. Copyright
        </Typography>
        <Typography sx={{margin: '0 0 20px 0 '}}>
        Copyright (c), University of Tübingen. All rights reserved.
        All content published on this website (layout, text, images, graphics, video and sound files, etc.) is subject to copyright. Any use not permitted by copyright law requires the prior express consent of the University of Tübingen. This applies in particular to the copying, editing, translation, storage, processing and reproduction of content in databases or other electronic media or systems. Photocopies and downloads of web pages for private, academic and non-commercial use are permitted.
        The copyright for the University of Tübingen logo is expressly held by the University of Tübingen.
        We expressly permit and welcome the citation of our documents and web pages as well as the setting of links to our website.
        </Typography>
        <Typography fontWeight='medium' marginBottom={1}>
            3. Disclaimer
        </Typography>
        <Typography sx={{margin: '0 0 20px 0 '}}>
        The information on this website has been carefully compiled and checked to the best of our knowledge and belief. However, no guarantee - neither explicit nor implicit - is given for the completeness, correctness or topicality nor of the availability of the information provided at any time. Liability for damages resulting from the use or non-use of the information provided on this website is - as far as legally permissible - excluded.
        </Typography>

        <Typography fontWeight='medium' marginBottom={1}>
            Public Relations Department
        </Typography>
        <Typography sx={{margin: '0 0 20px 0 '}}>
        Dr. Karl Guido Rijkhoek <br/>
        Wilhelmstrasse 5 <br/>
        72074 Tübingen, Germany <br/>
        E-mail ord@uni-tuebingen <br/>
        Phone  +49 7071 29-77854 <br/>
        </Typography>
        <Typography sx={{margin: '0 0 20px 0 '}}>
            This page was last updated on 15.05.2023    
        </Typography>
    </Box>
    );
}


